var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wide btn-primary",attrs:{"type":"submit","disabled":_vm.inSubmission,"tabindex":"1"}},[(!_vm.inSubmission)?_c('span',[_vm._t("default")],2):_vm._e(),_c('Spinner',{attrs:{"isLoading":_vm.inSubmission}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }